import styled from 'styled-components';
import { Popover } from '../popover';
import { BorderTop } from '../../../src/styled/shared-styles';
import { getColor, getColorShade, getThemeProp, getElevation, getSizeBy } from '../../../src/styled/utils';
import { Z_INDEXES } from '../../../src/styled/global-variables';
import { Subtitle1Styles, Subtitle2Styles } from '../typography';
export const StyledPopover = styled(Popover) `
  z-index: ${Z_INDEXES.LIGHTBOX};
  background-color: ${getColor('surface')};
  border-radius: ${getThemeProp('borderRadius')}px;
  outline: 0;
  box-shadow: ${getElevation(8)};
`;
export const StyledMenuListItem = styled.div `
  ${Subtitle2Styles};

  & + & {
    ${BorderTop}
  }

  display: flex;
  align-items: center;
  padding: ${getSizeBy(2.5)} ${getSizeBy(3)};
  color: ${({ disabled, checked }) => {
    if (disabled)
        return getColorShade('onSurface', 'lowEmphasis');
    if (checked)
        return getColor('primary');
    return getColorShade('onSurface', 'mediumEmphasis');
}};
  background-color: ${({ checked, focused }) => {
    if (checked)
        return getColorShade('primary', 'selected');
    if (focused)
        return getColorShade('primary', 'focused');
    return getColor('surface');
}};
  cursor: default;
  pointer-events: ${({ disabled }) => disabled && 'none'};

  &:hover {
    color: ${({ checked }) => checked ? getColor('primary') : getColorShade('onSurface', 'highEmphasis')};
    background-color: ${getColorShade('primary', 'hover')};
  }

  &:focus {
    background-color: ${getColorShade('primary', 'focused')};
    outline: 0;
  }

  &:active {
    color: ${getColor('primary')};
    background-color: ${getColorShade('primary', 'pressed')};
  }

  &:last-child {
    box-shadow: none;
  }
`;
export const CreateOptionWrapper = styled(StyledMenuListItem) `
  ${Subtitle1Styles};
  display: flex;
  flex-direction: row;
  gap: ${getSizeBy(1.5)};
  align-items: center;
  color: ${getColor('primary')};
  cursor: pointer;

  & > svg > path {
    fill: ${getColor('primary')};
  }

  &:hover {
    color: ${getColor('primary')};
  }
`;
export const ListComponentWrap = styled.div `
  background-color: ${getColor('surface')};
`;
